import React, { useState } from 'react';
import { faArrowCircleUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip } from 'antd';
import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';

const ScrollButton = () =>{
  
    const [visible, setVisible] = useState(false)
    
    const toggleVisible = () => {
      const scrolled = (document.querySelector('.main-header') as HTMLElement)?.getBoundingClientRect().top;
      if (scrolled < -300){
        setVisible(true)
      } 
      else if (scrolled >= -300){
        setVisible(false)
      }
    };
    
    const scrollToTop = () =>{
      const container = document.querySelector('.scrollbar-container')
      const skip = ((container?.scrollTop ?? 1000) * 100)/ (container?.scrollTop ?? 1000);
      if (!!container) {
        const interval = setInterval(() => {
          if (container.scrollTop > 0)
            container.scrollTop -= skip;
          else
            clearInterval(interval)
        })
      }
    };
    
    setTimeout(() => document?.querySelector('.scrollbar-container')?.addEventListener('scroll', toggleVisible), 300);
    
    return (
      <Tooltip title="Scroll to top">
        <Button
          id="scrollButton"
          onClick={scrollToTop}
          style={{display: visible ? 'inline' : 'none'}}
          type="primary"
          shape="circle"
          size="large"
          icon={
            <FontAwesomeIcon  
              icon={faArrowUp}
            />
          }
        />
      </Tooltip>
    );
  }
    
  export default ScrollButton;